import type { QueryClient, QueryKey } from "@tanstack/react-query";

/**
 * queryFn の中から「キャッシュ済みデータの再取得（ポーリング・invalidate）」かを判定する。
 * 初回取得と fetchNextPage（ページ追加）は false。Sentry のトレース除外（traceless）の判定に使う。
 */
export const isCachedRefetch = (
  client: QueryClient,
  queryKey: QueryKey,
): boolean =>
  client.getQueryData(queryKey) !== undefined &&
  client.getQueryState(queryKey)?.fetchMeta?.fetchMore == null;
